export const iconFontAwesomeArrowsArrowUp91 = (
	<i className="fa-solid fa-arrow-up-9-1"></i>
);
